/**
 * @generated SignedSource<<3a502b621a845aacb92a06649a8dd4ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateDocusignVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateDocusignVerificationKeyMutation$variables = {
  input: CreateDocusignVerificationKeyInput;
};
export type CreateDocusignVerificationKeyMutation$data = {
  readonly createDocusignVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type CreateDocusignVerificationKeyMutation = {
  variables: CreateDocusignVerificationKeyMutation$variables;
  response: CreateDocusignVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateDocusignVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createDocusignVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateDocusignVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateDocusignVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5eade3cf8da64dff77878710df97c5ce",
    "id": null,
    "metadata": {},
    "name": "CreateDocusignVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation CreateDocusignVerificationKeyMutation(\n  $input: CreateDocusignVerificationKeyInput!\n) {\n  createDocusignVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc1f3128400e73fb36ac9d6f972a3ae0";

export default node;
